<app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
  <app-customers-tab></app-customers-tab>
  <app-drafts-tab></app-drafts-tab>
</app-tabs>
